import { createContext, PropsWithChildren } from "react";
import { flags, FeatureFlags } from "../feature-flags";

export const FeatureFlagContext = createContext<FeatureFlags>(flags);

interface IFeatureFlagProviderProps {}

export function FeatureFlagProvider({
  children,
}: PropsWithChildren<IFeatureFlagProviderProps>) {
  return (
    <FeatureFlagContext.Provider value={flags}>
      {children}
    </FeatureFlagContext.Provider>
  );
}
